import { ASTRO_MAP_REPORT_MODAL_V1_PLAN_ID } from "@/features/subscriptions/report-plan-codes"
import { ReportIds } from "@/features/today/config/reports-data"

import type { AppModalComponentProps } from "../config/modal-registry"
import { ReportPromoModalV1, type ReportPromoCopyV1 } from "./report-promo-modal-v1"

const COPY: ReportPromoCopyV1 = {
  reportId: ReportIds.AstroMap,
  planId: ASTRO_MAP_REPORT_MODAL_V1_PLAN_ID,
  title: "Unlock Your Astro Map",
  description:
    "Discover the places that may support your love, career, money, calm, and personal growth",
}

export function ReportAstroMapModalV1(props: AppModalComponentProps) {
  return <ReportPromoModalV1 {...props} copy={COPY} />
}
